import { DeleteButton } from "@/shared/form/button";
import { DeleteButtonProps } from "@/shared/form/button/delete-button/delete-button";
import { useTranslations } from "use-intl";

export function DeleteGroupButtonView(props: DeleteButtonProps) {
  const t = useTranslations("DeleteGroupButton");

  return (
    <DeleteButton
      title={<div>{t("Are you sure you want to delete this group?")}</div>}
      description={
        <div>{t("This action delete all attributes in this group")}</div>
      }
      {...props}
    >
      {t("Delete group")}
    </DeleteButton>
  );
}
